'use client';

type TabType = 'pre' | 'post';

interface PresentationTabNavigationProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  isPostTabDisabled?: boolean;
  disabledMessage?: string;
}

export default function PresentationTabNavigation({ activeTab, onTabChange, isPostTabDisabled = false, disabledMessage = 'Create the presentation first' }: PresentationTabNavigationProps) {
  return (
    <div className="flex gap-8 border-b border-gray-200 mb-8">
      <button className={`px-5 py-2 ${activeTab === 'pre' ? 'text-[#5167b2] border-b-4 border-[#5167b2] font-bold' : 'text-gray-400 hover:text-[#5167b2] font-semibold'} bg-transparent rounded-t-xl focus:outline-none cursor-pointer`} onClick={() => onTabChange('pre')}>
        Pre Event
      </button>
      <button className={`px-5 py-2 ${activeTab === 'post' ? 'text-[#5167b2] border-b-4 border-[#5167b2] font-bold' : 'text-gray-400 hover:text-[#5167b2] font-semibold'} bg-transparent rounded-t-xl focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer`} onClick={() => onTabChange('post')} disabled={isPostTabDisabled} title={isPostTabDisabled ? disabledMessage : ''}>
        Post Event
      </button>
    </div>
  );
}
